import { Pressable, Modal as RNModal, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { h4 } from '@nxt-insurance/ui-kit/core/typography'

import { Icon } from '@/components/Icon'
import ButtonIcon from '@ui-kit/components/ButtonIcon'

export const MAX_MODAL_WIDTH = 600

const modalStyles = tv({
  slots: {
    backdrop: 'flex flex-1 flex-col items-center justify-center bg-backdrop',
    modalContainer:
      'relative mx-auto mt-20 flex justify-center rounded-xl bg-ui-light px-4 py-5 md:w-full md:max-w-[600px]',
    closeButtonContainer: 'absolute left-0 top-0 flex w-full flex-row justify-end px-4 pt-5',
    modalTitle: [h4(), 'pb-3'],
  },
})

export const Modal = (props: {
  visible: boolean
  onClose: () => void
  children?: React.ReactNode
}) => {
  const { backdrop, modalContainer, closeButtonContainer } = modalStyles()

  if (typeof document !== 'undefined') {
    document.body.classList.remove('overflow-y-hidden')
    if (props.visible) {
      document.body.classList.add('overflow-y-hidden')
    }
  }

  return (
    <RNModal transparent animationType="fade" visible={props.visible}>
      <Pressable className={backdrop()} onPress={props.onClose}>
        <View className={modalContainer()}>
          <View className={closeButtonContainer()}>
            <ButtonIcon
              onPress={props.onClose}
              icon={
                <Icon
                  size="small"
                  icon={{
                    name: 'action.close_24',
                  }}
                />
              }
            />
          </View>
          {props.children}
        </View>
      </Pressable>
    </RNModal>
  )
}
